<i18n>
{
  "fr": {
    "error-404-title": "Oups!",
    "error-404-subtitle": "Page introuvable",
    "error-404-text": "La page que vous tentez d'afficher n'est plus disponible.",
    "error-404-return": "Retour à l'accueil"
  },
  "en": {
    "error-404-title": "Oups !",
    "error-404-subtitle": "Page not found",
    "error-404-text": "The page you requested is no longer available.",
    "error-404-return": "Return to home page"
  }
}
</i18n>

<template>
  <div class="card">
    <ui-heading :title="$t('error-404-title')" :subtitle="$t('error-404-subtitle')" />

    <ui-box>
      <div class="has-max-width-768">
        <p class="mb-24px is-size-5">{{ $t('error-404-text') }}</p>
        <b-button type="is-link" outlined icon-left="arrow-left" tag="router-link" to="/">
          {{ $t('error-404-return') }}
        </b-button>
      </div>
    </ui-box>
  </div>
</template>

<script>
import UiBox from '@/components/ui/box'
import UiHeading from '@/components/ui/heading'

export default {
  components: { UiBox, UiHeading }
}
</script>
